import { render, staticRenderFns } from "./CompanyFrom.vue?vue&type=template&id=3555483c&"
import script from "./CompanyFrom.vue?vue&type=script&lang=js&"
export * from "./CompanyFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports